import {Button, IconButton, Stack, TextField, Typography,} from '@mui/material';
import React, {useEffect, useState} from 'react';
import Dialog from "@mui/material/Dialog";
import {TransitionProps} from "@mui/material/transitions";
import Grow from "@mui/material/Slide";
import {DEVICE, FONT_SIZE, STAND} from "./util/ObjectTypes";
import {IExhibitor} from "../../common/interfaces/exhibitor";
import {DataGrid, GridColDef, GridRowSelectionModel} from '@mui/x-data-grid';
import {
    fetchExhibitors,
    fetchExhibitorsByIds
} from "../../api/exhibitors";
import Tooltip from "@mui/material/Tooltip";
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import {createToastNotification} from "../../utilities/helpers";
import {fetchDevice, fetchDevicesByFair} from "../../api/devices";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import CancelIcon from '@mui/icons-material/Cancel';
import ConfirmationModal from "../../components/ConfirmationModal";

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Grow in={true} ref={ref} {...props}/>;
});

export const FloorCard = ({
                              fairID,
                              floorPlanID,
                              isVisible,
                              setIsVisible,
                              selectedObject,
                              handleSaveObjectMetaData,
                              setSelectedObject,
                              removeAllExhibitorsFromObject,
                              canvas,
                              updateTextInGroup
                          }: any) => {

    // use state for stands - exhibitors
    const [eName, setEName] = useState<string>('');
    const [eDescription, setEDescription] = useState<string>('')
    const [eLink, setELink] = useState<string>('');
    const [eClass, setEClass] = useState<string>('');
    const [eBoothNumber, setEBoothNumber] = useState<string>('');
    const [eLogoPreview, setELogoPreview] = useState<string | null>(null);

    const [confirmDeleteDialogIsOpened, setConfirmDeleteDialogIsOpened] = useState(false)

    const [
        selectedExhibitors,
        setSelectedExhibitors
    ] = useState<IExhibitor[]>([]);

    const clearInputForExhibitors = () => {
        setEName('')
        setEDescription('')
        setELink('')
        setEClass('')
        setEBoothNumber('')
        setELogoPreview(null);
    }

    const initialExhibitorFetch = async () => {

        if(!floorPlanID){
            return;
        }

        const data = {
            page: ePage,
            perPage: ePerPage,
            floorPlan:floorPlanID
        };

        try {

            let response = await fetchExhibitors(fairID, data);

            let alreadyOnStand: IExhibitor[] = [];
            if (selectedObject?.metadata?.ids?.length > 0) {
                const alreadyOnStandResponse = await fetchExhibitorsByIds(selectedObject.metadata.ids);
                if (alreadyOnStandResponse.exhibitors.length > 0) {
                    alreadyOnStand = alreadyOnStandResponse.exhibitors;
                }
            }

            setSelectedExhibitors(alreadyOnStand)

            const mergedExhibitors = [...alreadyOnStand, ...response.exhibitors].filter(
                (exhibitor, index, self) =>
                    index === self.findIndex((e) => e.id === exhibitor.id)
            );

            setExhibitorsData(mergedExhibitors)
            setTotalExhibitors(response.totalItems)
            setIsInitialExhibitorFetch(false)
        } catch (error: any) {
            createToastNotification('error', error?.response?.data?.message);
        }
    }

    const handleFetchExhibitors = async (search?: string) => {

        if(!floorPlanID){
            return;
        }

        const data = {
            page: ePage,
            perPage: ePerPage,
            floorPlan:floorPlanID
        };

        if (search != undefined) {
            // @ts-ignore
            data.search = search
        }else if (eSearch.length > 0) {
            // @ts-ignore
            data.search = eSearch
        }

        try {
            let response = await fetchExhibitors(fairID, data);
            const mergedExhibitors = [...selectedExhibitors, ...response.exhibitors].filter(
                (exhibitor, index, self) =>
                    index === self.findIndex((e) => e.id === exhibitor.id)
            );

            setExhibitorsData(mergedExhibitors)
            setTotalExhibitors(response.totalItems)
        } catch (error: any) {
            createToastNotification('error', error?.response?.data?.message);
        }

    }

    const handleSelectedExhibitorsChange = (newSelection: GridRowSelectionModel) => {

        setSelectedExhibitors((prevSelected) => {
            return exhibitorsData.filter((exhibitor) =>
                newSelection.includes(exhibitor.id)
            );
        });

    }

    const clearESearchInput = () => {
        setESearch('')
    }

    const handleERowClick = async (params: { row: { id: any } }) => {

        //@ts-ignore
        setEName(params.row.name)
        //@ts-ignore
        setEDescription(params.row.description)
        //@ts-ignore
        setEBoothNumber(params.row.boothNumber)
        //@ts-ignore
        setELink(params.row.link)
        //@ts-ignore
        setEClass(params.row.exhibitorClass)

        //@ts-ignore
        if (params.row.logoUrl) {
            //@ts-ignore
            setELogoPreview(params.row.logoUrl)
        } else {
            setELogoPreview(null);
        }
    }

    const attachExhibitorsToStand = ()=>{

        if(!selectedExhibitors.length){
            createToastNotification('info', 'Obaderite izlagače');
            return
        }

        let exhibitorIds:number[] = [];
        let standNumber: string | null = null;
        for(let i=0;i<selectedExhibitors.length;i++){
            exhibitorIds.push(selectedExhibitors[i].id)
            if(standNumber === null){
                standNumber = selectedExhibitors[i].boothNumber
                continue;
            }

            if(standNumber !== selectedExhibitors[i].boothNumber){
                createToastNotification('error', 'Obaderite izlagače sa istim brojem štanda');
                return;
            }
        }

        if(standNumber===null){
            return
        }

        try {

            handleSaveObjectMetaData(selectedObject, exhibitorIds, standNumber)
            createToastNotification('success', 'Izabrani izlagači su dodeljeni objektu')
            setIsVisible(false)
            const objects = canvas?.getObjects();
            // @ts-ignore
            const targetObject = objects.find((obj) => obj.id === selectedObject.canvasObjectID);
            if(targetObject) {
            updateTextInGroup(targetObject,FONT_SIZE)
            }
            clearInputForExhibitors()
            setSelectedObject(null)

        } catch (error: any) {
            createToastNotification('error', 'Dogodila se greška');
        }

    }


    const eColumns: GridColDef[] = [
        {field: 'id', headerName: 'ID', width: 70, sortable: false},
        {field: 'name', headerName: 'Naziv', width: 180, sortable: false},
        {field: 'boothNumber', headerName: 'Šifra štanda', width: 150, sortable: false},
        {field: 'description', headerName: 'Opis', type: 'string', width: 200, sortable: false},
        {field: 'exhibitorClass', headerName: 'Klasa', type: 'string', width: 100, sortable: false},
        {field: 'link', headerName: 'Link', type: 'string', width: 100, sortable: false},
    ];

    const [exhibitorsData, setExhibitorsData] = useState<IExhibitor[]>( []);
    const [totalExhibitors, setTotalExhibitors] = useState<number>(0);
    const [eSearch, setESearch] = useState<string>('');
    const [ePage, setEPage] = useState<number>(1);
    const [ePerPage, setEPerPage] = useState<number>(5);
    const paginationModel = {page: ePage, pageSize: ePerPage};


    const [
        isInitialExhibitorFetch,
        setIsInitialExhibitorFetch
    ] = useState<boolean>(true)

    //
    //
    //  devices
    //
    //
    const dColumns: GridColDef[] = [
        {field: 'id', headerName: 'ID', width: 70, sortable: false},
        {field: 'ipAddress', headerName: 'IP Adresa', width: 180, sortable: false},
        {field: 'status', headerName: 'Status', width: 180, sortable: false},
        {field: 'name', headerName: 'Naziv uređaja', width: 150, sortable: false},
        {field: 'description', headerName: 'Opis', width: 150, sortable: false}
    ];

    const [devicesData, setDevicesData] = useState<{
        id:number,
        ipAddress:string,
        status:string,
        name:string,
        description:string;
    }[]>( []);

    //use state for devices
    const [dID, setDID] = useState<number | null>(null);
    const [dIPAddress, setDIPAddress] = useState<string>('');
    const [dStatus, setDStatus] = useState<string>('');
    const [dName, setDName] = useState<string>('');
    const [dDescription, setDDescription] = useState<string>('')
    const [dSearch, setDSearch] = useState<string>('');
    //
    const [totalDevices, setTotalDevices] = useState<number>(0);
    const [dPage, setDPage] = useState<number>(1);
    const [dPerPage, setDPerPage] = useState<number>(5);
    const dPaginationModel = {page: dPage, pageSize: dPerPage};

    const clearInputForDevice = () => {
        setDID(null)
        setDIPAddress('')
        setDName('')
        setDStatus('')
        setDDescription('')
    }

    const clearDSearchInput = () => {
        setDSearch('')
    }

    const handleFetchDevices = async (search?: string) => {

        const data = {
            page: dPage,
            perPage: dPerPage
        };

        if (search != undefined) {
            // @ts-ignore
            data.search = search
        }else if (dSearch.length > 0) {
            // @ts-ignore
            data.search = dSearch
        }

        try {
            let response = await fetchDevicesByFair(data,fairID);
            setDevicesData(response.devices)
            setTotalDevices(response.totalItems)
        } catch (error: any) {
            createToastNotification('error', error?.response?.data?.message);
        }

    }
    const handleDRowClick = async (params: { row: { id: any } }) => {

        setDID(params.row.id)
        //@ts-ignore
        setDIPAddress(params.row.ipAddress)
        //@ts-ignore
        setDStatus(params.row.status)
        //@ts-ignore
        setDName(params.row.name)
        //@ts-ignore
        setDDescription(params.row.description)
    }

    const fetchDeviceAndPopulateForm = async (deviceID: number) => {
        try {
            const response = await fetchDevice(deviceID)
            if (response.device) {
                setDID(response.device.id ?? null);
                setDName(response.device.name ?? '');
                setDStatus(response.device.status ?? '')
                setDIPAddress(response.device.ipAddress ?? '')
                setDDescription(response.device.description ?? '')
            }

        } catch (error: any) {
            createToastNotification('error', error?.response?.data?.message);
        }
    }

    const handleAssignDeviceToObject = () => {

        if(dID){
            handleSaveObjectMetaData(selectedObject, [dID])
            setIsVisible(false)
        }
    }

    useEffect(() => {

        if (isVisible) {
            if (selectedObject.metadata.type === STAND) {
                if(isInitialExhibitorFetch){
                    initialExhibitorFetch()
                }else{
                    handleFetchExhibitors()
                }
            } else if (selectedObject.metadata.type === DEVICE) {
                handleFetchDevices()
            }
        }
    }, [isVisible, ePage, ePerPage, dPage, dPerPage]);

    useEffect(() => {
        if (
            isVisible &&
            selectedObject &&
            selectedObject.metadata &&
            selectedObject.metadata.ids &&
            selectedObject.metadata.type === DEVICE &&
            selectedObject.metadata.ids[0]
        ) {
            fetchDeviceAndPopulateForm(selectedObject.metadata.ids[0])
        } else if (isVisible === false) {
            clearInputForExhibitors()
            clearESearchInput()
            clearInputForDevice()
            clearDSearchInput()
            setSelectedExhibitors([])
            setIsInitialExhibitorFetch(true)
        }
    }, [isVisible]);

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'lg'}
            open={isVisible}
            onClose={() => {
                setIsVisible(false)
            }}
            TransitionComponent={Transition}
        >
            <Stack
                height='950px'
            >
                {selectedObject?.metadata.type === STAND &&
                    <>
                        <Stack sx={{paddingTop: 5, paddingLeft: 5, paddingRight: 5}}>
                            <Stack direction="row" alignItems="center" justifyContent="space-between">
                                <Stack direction="row" alignItems="center" justifyContent="space-between">
                                    <Tooltip title="Zatvori" arrow>
                                        <IconButton
                                            sx={{marginRight: 1}}
                                            onClick={() => {
                                                setIsVisible(false)
                                            }}
                                        >
                                            <CancelIcon color='error'/>
                                        </IconButton>
                                    </Tooltip>
                                    <Typography>{'Izlagači'}</Typography>
                                </Stack>
                                <Stack direction="row" alignItems="center" justifyContent="space-between">
                                    <Tooltip title="Očisti unos" arrow>
                                        <IconButton
                                            sx={{marginRight:1}}
                                            onClick={()=>{
                                                clearESearchInput()
                                                clearInputForExhibitors()
                                                handleFetchExhibitors('')
                                            }}
                                        >
                                            <CleaningServicesIcon color="action" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Obriši izlagače sa štanda" arrow>
                                        <IconButton
                                            sx={{ marginRight: 1 }}
                                            onClick={() => {

                                                setConfirmDeleteDialogIsOpened(true);
                                            }}
                                        >
                                            <DeleteOutlineIcon color="error" />
                                        </IconButton>
                                    </Tooltip>
                                    <Button
                                        sx={{marginLeft:1}}
                                        variant="contained"
                                        color="success"
                                        onClick={attachExhibitorsToStand}
                                    >
                                        Dodeli izlagače objektu
                                    </Button>
                                </Stack>
                            </Stack>
                            <Stack direction="row" alignItems="start" justifyContent="space-between">
                                <Stack direction="column" alignItems="start" sx={{width:'90%'}}>
                                    <TextField
                                        size={'small'}
                                        sx={{width:'90%'}}
                                        label="Naziv"
                                        name="name"
                                        value={eName}
                                        margin="normal"
                                    />
                                    <TextField
                                        size={'small'}
                                        sx={{width:'90%'}}
                                        label="Broj štanda"
                                        value={eBoothNumber}
                                        margin="normal"
                                        name="boothNumber"
                                    />
                                    <TextField
                                        size={'small'}
                                        sx={{width:'90%'}}
                                        label="Klasa izlagača"
                                        value={eClass}
                                        margin="normal"
                                        name="level"
                                    />
                                    <TextField
                                        size={'small'}
                                        sx={{width:'90%'}}
                                        label="Link"
                                        value={eLink}
                                        margin="normal"
                                        name="link"
                                    />
                                </Stack>

                                <Stack direction="column" alignItems="start" justifyContent="space-between" sx={{width:'90%'}}>

                                    <TextField
                                        sx={{width:"90%"}}
                                        label="Opis"
                                        name="description"
                                        value={eDescription}
                                        margin="normal"
                                        multiline
                                        rows={4}
                                    />
                                    <Stack spacing={2} marginTop={2} sx={{width:'90%'}}>
                                        <Typography variant="body1">Logo</Typography>
                                        {eLogoPreview && (
                                            <Stack direction="row" alignItems="center" spacing={1}>
                                                <img
                                                    src={eLogoPreview}
                                                    alt="Preview"
                                                    style={{
                                                        width: 100,
                                                        height: 100,
                                                        borderRadius: '50%',
                                                        objectFit: 'cover',
                                                    }}
                                                />
                                            </Stack>
                                        )}
                                    </Stack>
                                </Stack>
                            </Stack>

                            <Stack
                                sx={{
                                    marginTop: 1,
                                    marginBottom: 2,
                                    borderRadius: "20px",
                                    padding: '10px',
                                    paddingBottom: '0px',
                                    border: '1px solid #e0e0e0',
                                    backgroundColor: '#f9f9f9',
                                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                            }}>
                                <Stack direction="row" alignItems="center">
                                    <TextField
                                        sx={{
                                            width: '500px',
                                            height: '50px',
                                            marginRight: '20px',
                                            '& .MuiInputBase-root': {
                                                backgroundColor: 'white',
                                                borderRadius: '5px',
                                                padding: 0,
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#d0d0d0',
                                            },
                                        }}
                                        label="Pretraga"
                                        name="name"
                                        size="small"
                                        value={eSearch}
                                        onChange={(e) => {
                                            setESearch(e.target.value);
                                        }}
                                        margin="normal"
                                    />
                                    <Tooltip title="Pretraži">
                                        <IconButton
                                            onClick={()=>{
                                                handleFetchExhibitors()
                                            }}
                                            color="primary"
                                            size="medium"
                                            sx={{
                                                backgroundColor: '#f0f0f0',
                                                '&:hover': {
                                                    backgroundColor: '#e0e0e0',
                                                },
                                            }}
                                        >
                                            <SearchIcon />
                                        </IconButton>
                                    </Tooltip>

                                    {eSearch.length>0 &&
                                        <Tooltip title="Očisti unos">
                                        <IconButton
                                            onClick={()=>{
                                                clearESearchInput()
                                                handleFetchExhibitors('')
                                            }}
                                            color="error"
                                            size="medium"
                                            sx={{
                                                marginLeft:1,
                                                backgroundColor: '#f0f0f0',
                                                '&:hover': {
                                                    backgroundColor: '#e0e0e0',
                                                },
                                            }}
                                        >
                                            <ClearIcon />
                                        </IconButton>
                                    </Tooltip>}
                                </Stack>

                                <DataGrid
                                    disableColumnMenu
                                    disableRowSelectionOnClick
                                    rows={exhibitorsData}
                                    rowCount={totalExhibitors}
                                    columns={eColumns}
                                    onRowClick={handleERowClick}
                                    pagination
                                    paginationModel={{
                                        page: paginationModel.page - 1,
                                        pageSize: paginationModel.pageSize
                                    }}
                                    paginationMode={'server'}
                                    pageSizeOptions={[5, 10]}
                                    //@ts-ignore
                                    onPaginationModelChange={(model) =>{
                                        setEPage(model.page + 1)
                                        setEPerPage(model.pageSize)
                                    }}
                                    sx={{ border: 0 }}
                                    getRowClassName={(params) => params.row.isUsed && !selectedObject?.metadata?.ids.includes(params.row.id) ? 'disabled-row' : ''}
                                    checkboxSelection
                                    rowSelectionModel={selectedExhibitors.map((e)=>e.id)}
                                    onRowSelectionModelChange={(newSelection) => {
                                        handleSelectedExhibitorsChange(newSelection)
                                    }}
                                    localeText={{
                                        MuiTablePagination: {
                                            labelRowsPerPage: "Redova po strani",
                                            labelDisplayedRows: ({from, to, count}) =>
                                                `${from} od ${count !== -1 ? count : ` od ${to}`}`,
                                        },
                                        noRowsLabel: "Nema dostupnih podataka",
                                    }}
                                />

                            </Stack>

                        </Stack>
                    </>
                }
                {
                    selectedObject?.metadata.type === DEVICE &&
                    <>
                        <Stack sx={{paddingTop: 5, paddingLeft: 5, paddingRight: 5}}>
                            <Stack direction="row" alignItems="center" justifyContent="space-between">
                                <Stack direction="row" alignItems="center" justifyContent="space-between">
                                    <Tooltip title="Zatvori" arrow>
                                        <IconButton
                                            sx={{marginRight: 1}}
                                            onClick={() => {
                                                setIsVisible(false)
                                            }}
                                        >
                                            <CancelIcon color='error'/>
                                        </IconButton>
                                    </Tooltip>
                                    <Typography>Uređaj</Typography>
                                </Stack>
                                <Stack direction="row" alignItems="center" justifyContent="space-between">
                                    <Button
                                        sx={{marginRight:1}}
                                        variant="contained"
                                        color="primary"
                                        onClick={()=>{
                                            handleAssignDeviceToObject()
                                        }}
                                    >
                                        Dodeli uređaj objektu
                                    </Button>
                                </Stack>
                            </Stack>
                            <Stack direction="row" alignItems="start" justifyContent="space-between">
                                <Stack direction="column" alignItems="start" sx={{width:'90%'}}>
                                    <TextField
                                        size={'small'}
                                        sx={{width:'90%'}}
                                        label="IP adresa"
                                        name="dIPAddress"
                                        value={dIPAddress}
                                        margin="normal"
                                    />
                                    <TextField
                                        size={'small'}
                                        sx={{width:'90%'}}
                                        label="Status"
                                        name="dStatus"
                                        value={dStatus}
                                        margin="normal"
                                    />
                                    <TextField
                                        size={'small'}
                                        sx={{width:'90%'}}
                                        label="Naziv"
                                        value={dName}
                                        margin="normal"
                                        name="dName"
                                    />
                                </Stack>

                                <Stack direction="column" alignItems="start" justifyContent="space-between" sx={{width:'90%'}}>
                                    <TextField
                                        sx={{width:"90%"}}
                                        label="Opis"
                                        name="dDescription"
                                        value={dDescription}
                                        margin="normal"
                                        multiline
                                        rows={4}
                                    />
                                </Stack>
                            </Stack>

                            <Stack
                                sx={{
                                    marginTop: 1,
                                    marginBottom: 2,
                                    borderRadius: "20px",
                                    padding: '10px',
                                    paddingBottom: '0px',
                                    border: '1px solid #e0e0e0',
                                    backgroundColor: '#f9f9f9',
                                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                                }}>
                                <Stack direction="row" alignItems="center">
                                    <TextField
                                        sx={{
                                            width: '500px',
                                            height: '50px',
                                            marginRight: '20px',
                                            '& .MuiInputBase-root': {
                                                backgroundColor: 'white',
                                                borderRadius: '5px',
                                                padding: 0,
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#d0d0d0',
                                            },
                                        }}
                                        label="Pretraga po IP adresi ili nazivu"
                                        name="dSearch"
                                        size="small"
                                        value={dSearch}
                                        onChange={(e) => {
                                            setDSearch(e.target.value);
                                        }}
                                        margin="normal"
                                    />
                                    <Tooltip title="Pretraži">
                                        <IconButton
                                            onClick={()=>{
                                                handleFetchDevices()
                                            }}
                                            color="primary"
                                            size="medium"
                                            sx={{
                                                backgroundColor: '#f0f0f0',
                                                '&:hover': {
                                                    backgroundColor: '#e0e0e0',
                                                },
                                            }}
                                        >
                                            <SearchIcon />
                                        </IconButton>
                                    </Tooltip>

                                    {dSearch.length>0 &&
                                        <Tooltip title="Očisti unos">
                                            <IconButton
                                                onClick={()=>{
                                                    clearDSearchInput()
                                                    handleFetchDevices('')
                                                }}
                                                color="error"
                                                size="medium"
                                                sx={{
                                                    marginLeft:1,
                                                    backgroundColor: '#f0f0f0',
                                                    '&:hover': {
                                                        backgroundColor: '#e0e0e0',
                                                    },
                                                }}
                                            >
                                                <ClearIcon />
                                            </IconButton>
                                        </Tooltip>}
                                </Stack>

                                <DataGrid
                                    rows={devicesData}
                                    rowCount={totalDevices}
                                    columns={dColumns}
                                    onRowClick={handleDRowClick}
                                    pagination
                                    paginationModel={{
                                        page: dPaginationModel.page - 1,
                                        pageSize: dPaginationModel.pageSize
                                    }}
                                    paginationMode={'server'}
                                    pageSizeOptions={[5, 10]}
                                    //@ts-ignore
                                    onPaginationModelChange={(model) =>{
                                        setDPage(model.page + 1)
                                        setDPerPage(model.pageSize)
                                    }}
                                    sx={{ border: 0 }}
                                    getRowClassName={(params) => params.row.isUsed && params.row.id!== selectedObject?.metadata?.ids[0] ? 'disabled-row' : ''}
                                    localeText={{
                                        MuiTablePagination: {
                                            labelRowsPerPage: "Redova po strani",
                                            labelDisplayedRows: ({from, to, count}) =>
                                                `${from} od ${count !== -1 ? count : ` od ${to}`}`,
                                        },
                                        noRowsLabel: "Nema dostupnih podataka",
                                    }}
                                    disableColumnMenu
                                    disableRowSelectionOnClick
                                />

                            </Stack>

                        </Stack>
                    </>
                }
            </Stack>
            {confirmDeleteDialogIsOpened && (
                <ConfirmationModal
                    confirmationModalTitle="Uklanjanje svih izlagača sa štanda"
                    cancelAction={() => {
                        setConfirmDeleteDialogIsOpened(false);
                    }}
                    handleAction={() => {
                        try {
                            removeAllExhibitorsFromObject(selectedObject)
                            setIsVisible(false)
                            createToastNotification('success', 'Svi izlagači su uklonjeni sa štanda');
                        } catch (error: any) {
                            createToastNotification('error', 'Dogodila se greška prilikom uklanjanja izlagača sa štanda');
                        }

                        setConfirmDeleteDialogIsOpened(false);
                    }
                    }
                    confirmBtnTitle="Potvrdi uklanjanje"
                    modalDescription="Da li ste sigurni da želite da uklonite sve izlagače sa štanda?"
                    cancelBtnTitle="Odustani"
                    confirmButtonColor={'red'}
                />
            )}
        </Dialog>
    );
};
